var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85705 14.0578C3.94642 13.9879 3.08116 13.632 2.38482 13.0411C1.68849 12.4501 1.19668 11.6542 0.979624 10.767C0.762569 9.8799 0.831365 8.94685 1.17619 8.10113C1.52101 7.25542 2.12423 6.54027 2.89972 6.05781C3.06473 4.77121 3.69292 3.58882 4.66673 2.73192C5.64055 1.87502 6.89324 1.40234 8.19039 1.40234C9.48753 1.40234 10.7402 1.87502 11.714 2.73192C12.6879 3.58882 13.316 4.77121 13.4811 6.05781C14.2565 6.54027 14.8598 7.25542 15.2046 8.10113C15.5494 8.94685 15.6182 9.8799 15.4011 10.767C15.1841 11.6542 14.6923 12.4501 13.9959 13.0411C13.2996 13.632 12.4344 13.9879 11.5237 14.0578V14.0705H4.85705V14.0578ZM8.85705 8.73715H10.8571L8.19039 5.40381L5.52372 8.73715H7.52372V11.4038H8.85705V8.73715Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.b74c264e.svg";
export { ForwardRef as ReactComponent };